import { paths } from "Constant/paths";
import React from "react";
import { Link } from "react-router-dom";

export const JobBox = ({ jobData }) => {
  return (
    <Link
      to={`${paths.careers}/${paths.careerDetails}/${jobData.gid}`}
      className={`${
        jobData.featured ? "featured-jobs featured-badge" : ""
      } border d-flex flex-column row-gap-3 text-decoration-none p-4 rounded-lg text-inherit h-100`}
    >
      <div className="d-flex gap-3 align-items-center">
        <div className="featured-job-icon flex-none w-14 h-14 rounded-lg d-flex justify-content-center align-items-center bg-primary-50  rounded-lg overflow-hidden">
          {jobData.image ? (
            <img
              src={jobData.image}
              alt={jobData.companyDetails?.name || ""}
              className="w-100 h-100 object-fit-cover"
            />
          ) : (
            <img
              src="/assets/images/placeholders/company-placeholder.svg"
              alt=""
              className="w-100 h-100 object-fit-cover"
            />
          )}
        </div>
        <div>
          <h4 className="mb-1 text-base font-semibold">
            {jobData.companyDetails?.name || ""}{" "}
            {jobData.featured && (
              <span className="px-2 py-1 rounded-pill text-xs text-red-500 bg-red-100">
                Featured
              </span>
            )}
          </h4>
          <p className="mb-0 text-sm text-grey-500 d-flex align-items-center gap-1">
            <i className="bx bx-map"></i>
            {jobData.location || ""}
          </p>
        </div>
      </div>
      <div>
        <h5 className="mb-0 text-md">{jobData.name}</h5>
        <ul className="mb-0 list-unstyled d-inline-flex gap-2 text-grey-500 text-xs font-medium">
          <li>{jobData.type}</li>
          {/* <li>|</li>
          <li>{jobData.salaryRange || ""}</li> */}
        </ul>
      </div>
    </Link>
  );
};
